import { createFileRoute } from '@tanstack/react-router'
import { ResearchIdRouteComponent } from './_layout.$id'

export const Route = createFileRoute('/dashboard/research/_layout/$id/')({
  component: ResearchIdRouteComponent,
})
